import { BaseResponseModel, FileResponse, IBaseResponseModel } from 'services/tenantManagementService';
import { catchError, defaultErrorResponse } from './fetchUtils';

interface IExportFileResponseModel extends IBaseResponseModel {
	value?: FileResponse
}

class ExportFileResponseModel extends BaseResponseModel {
	value?: FileResponse

    constructor(data?: IExportFileResponseModel) {
        if (data) {
			super(data);
			this.value = data.value;
        }
	}
}

export const tryCatchExportFileByAction = async (fetchFunction: (...args: any[]) => Promise<FileResponse>): Promise<ExportFileResponseModel> => {
	const fetchPromise = fetchFunction();

	try {
		const response = await fetchPromise;
		const model = new ExportFileResponseModel({
			success: true,
			value: response
		});
		return response ? model : defaultErrorResponse;
	}
	catch (error: any) {
		return catchError<BaseResponseModel>(error);
	}
}
